let hardExtend = [
  // 付帅收款码
  // [],
  // 云播报
  [],
  // 扫码机具
  // [
  //   {
  //     title: '付帅扫码神——FYS1款',
  //     h4: [
  //       '一体化设计，单手掌握，轻松操作。移动收款，易如反掌。'
  //     ],
  //     imgSrc: 'https://gzyit-yyx.oss-cn-beijing.aliyuncs.com/pc/imgs/hardware/hard_c_05.png'
  //   },
  //   {
  //     title: '付帅扫码神——FYS2款',
  //     h4: [
  //       '分体式设计，独立扫码器，防水机械键盘。双屏金额显示，轻松扫码。'
  //     ],
  //     imgSrc: 'https://gzyit-yyx.oss-cn-beijing.aliyuncs.com/pc/imgs/hardware/hard_c_06.png'
  //   },
  //   {
  //     title: '付帅扫码神——FYS3款',
  //     h4: [
  //       '同时支持二维码和条形码，毫秒级识别速度。屏蔽病毒二维码，收款更放心。',
  //       '注：此款需与收银台配合使用。'
  //     ],
  //     imgSrc: 'https://gzyit-yyx.oss-cn-beijing.aliyuncs.com/pc/imgs/hardware/hard_c_07.png'
  //   },
  //   {
  //     title: '付帅扫码神——FYS5款',
  //     h4: [
  //       '安卓系统更强劲，大屏幕更清晰，触屏操作更方便。'
  //     ],
  //     imgSrc: 'https://gzyit-yyx.oss-cn-beijing.aliyuncs.com/pc/imgs/hardware/hard_c_08.png'
  //   }
  // ],
  // 云打印
  [
    {
      title: '付帅云印神——FYP1款',
      h4: [
        'WIFI联网，220V（伏）市电供电，0.5秒极速打印。'
      ],
      imgSrc: 'https://gzyit-yyx.oss-cn-beijing.aliyuncs.com/pc/imgs/hardware/hard_d_05.png'
    },
    {
      title: '付帅云印神——FYP2款',
      h4: [
        'WIFI联网，12V（伏）电瓶供电，流动餐车也可有高端打印。'
      ],
      imgSrc: 'https://gzyit-yyx.oss-cn-beijing.aliyuncs.com/pc/imgs/hardware/hard_d_06.png'
    },
    {
      title: '付帅云印神——FYP3款',
      h4: [
        '内置充电电池，WIFI+GPRS+蓝牙联网，收款语音播报，打印机中的战斗机。'
      ],
      imgSrc: 'https://gzyit-yyx.oss-cn-beijing.aliyuncs.com/pc/imgs/hardware/hard_d_07.png'
    },
    {
      title: '付帅云印神——FYP4款',
      h4: [
        '一个小盒子，热敏机秒变云打印机。从此，线下店铺也是线上商城。'
      ],
      imgSrc: 'https://gzyit-yyx.oss-cn-beijing.aliyuncs.com/pc/imgs/hardware/hard_d_08.png'
    },
  ],
  // 其他设备
  [],
]

export default hardExtend



// WEBPACK FOOTER //
// ./src/assets/conf/hard_extend.js